export const validateCertificationForm = (formData) => {
    const errors = {};

    if (!formData.paymentDate) {
        errors.paymentDate = 'Ce champ est obligatoire';
    }

    if (!formData.declarantNumber) {
        errors.declarantNumber = 'Ce champ est obligatoire';
    } else if (!/^\d+$/.test(formData.declarantNumber)) {
        errors.declarantNumber = 'Valeur numerique uniquement';
    } else if (formData.declarantNumber.length > 15) {
        errors.declarantNumber = 'Maximum 15 chiffres';
    }

    if (!formData.billingExercise) {
        errors.billingExercise = 'Ce champ est obligatoire';
    } else if (!/^\d+$/.test(formData.billingExercise)) {
        errors.billingExercise = 'Valeur numerique uniquement';
    } else if (formData.billingExercise.length > 4) {
        errors.billingExercise = 'Maximum 4 chiffres';
    }

    if (!formData.operationType) {
        errors.operationType = 'Ce champ est obligatoire';
    }

    if (!formData.operation) {
        errors.operation = 'Ce champ est obligatoire';
    }

    if (!formData.isSupported) {
        errors.isSupported = 'Ce champ est obligatoire';
    }

    if (!formData.hasConvention) {
        errors.hasConvention = 'Ce champ est obligatoire';
    }

    return errors;
};

export const validateAmountsForm = (amountsData) => {
    const errors = {};

    if (!amountsData.montantHT && amountsData.montantHT !== 0) {
        errors.montantHT = 'Ce champ est obligatoire';
    } else if (isNaN(Number(amountsData.montantHT)) || Number(amountsData.montantHT) < 0) {
        errors.montantHT = 'Montant invalide';
    }

    return errors;
};
